module.exports = __webpack_public_path__ + "static/media/s-bahn.3e98b982.svg";